<template>
  <svg width="100%" height="100%" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.25 14.8349C28.9167 15.7972 28.9167 18.2028 27.25 19.1651L13.75 26.9593C12.0833 27.9215 10 26.7187 10 24.7942L10 9.20577C10 7.28127 12.0833 6.07845 13.75 7.04071L27.25 14.8349Z" stroke-width="3"/>
    <rect x="32" width="3" height="32" rx="1.5" />
  </svg>
</template>

<script>
export default {
  name: 'next-episode-icon'
}
</script>

<style lang="scss" scoped>
svg {
  & > path {
    stroke: $player-footer-icons-color;
  }

  & > rect {
    fill: $player-footer-icons-color;
  }
}
</style>
